import { f7 } from 'framework7-react';
import { signOutUser } from '../firebase';
import { clearSession } from './sessionManager';

export function handleLogout(onComplete?: () => void) {
  const dialog = f7.dialog.create({
    title: 'Sign out of DealSaver',
    text: 'You can sign back in anytime',
    buttons: [
      {
        text: 'Sign out',
        onClick: async () => {
          try {
            await signOutUser();
            try {
              await clearSession();
            } catch (err) {
              console.warn('Failed to clear session storage:', err);
              // Continue with logout despite session clear failure
            }
            f7.views.main.router.navigate('/', { reloadAll: true });
          } catch (error) {
            console.error(error);
            f7.dialog.alert('Failed to log out. Please try again.');
          }
          onComplete?.();
        },
      },
      {
        text: 'Cancel',
        onClick: () => {
          dialog.close();
          onComplete?.();
        },
      },
    ],
    verticalButtons: false,
  });
  dialog.open();
}
